import Error from '@/plugins/sdk/Error'

export default class RequestError extends Error {
  constructor (resource, request, response, ...params) {
    super(resource, request, response, params)
  }
}
